import { Fragment } from 'react';
import './dropdown.css';
import { Dropdown } from 'react-bootstrap';

const DropDown = ({ options = [], type = 'checkbox', onChange = () => {}, onClick = () => {}, title, name = '', htmlFor = '', className = '', dropdownClassName = '' }) => {
  return (
    <div className={`my-dropdown ${className}`}>
      <Dropdown>
        <Dropdown.Toggle className='custom-dropdown-style' variant='customized'>{title}</Dropdown.Toggle>
        {options.length > 0 && (
          <Dropdown.Menu className={dropdownClassName}>
            {options.map((option, i) => (
              <Fragment key={i}>
                {type === 'normal' || !type ? (
                  <h6
                    className={`cursor cust ${option.isChecked ? 'selected' : ''}`}
                    onClick={() => {
                      onChange(option.value);
                    }}
                  >
                    {option.title}
                  </h6>
                ) : (
                  <div className='cust cursor'>
                    <label>
                      <input onChange={onChange} onClick={onClick} type={`${type}`} value={option.value} className='custome_radio cursor' name={name} checked={option.isChecked} />
                      <span></span>
                      {option.title}
                    </label>
                  </div>
                )}
              </Fragment>
            ))}
          </Dropdown.Menu>
        )}
      </Dropdown>
    </div>
  );
};

export default DropDown;
